class PhoneCollect extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback () {
		this.initElements();
		this.initEvents();
	}

	initElements() {
		this.existedMasks = new Set();
		this.form = this.querySelector("[data-collect-form]");
		this.submitButton = this.querySelector("[data-collect-button]");
		this.collectMessages = this.querySelector("[data-collect-form-status-message]");
		this.formField = this.querySelector("[data-collect-form-field]");
	}

	initEvents() {
		if (this.form) {
			this.form.addEventListener("submit", (event) => {
				event.preventDefault();

				this.sendData();
			});
		}
	}
	sendData() {
		const phoneNumber = this.formField.value;
		const token = new URL(document.location.href).searchParams.get("token");

		if (!token) {
			return null;
		}

		mindbox("async", {
			operation: "EnrichByToken",
			data: {
				customer: {
					authenticationTicket: `${token}`,
					mobilePhone: `${phoneNumber}`,
					subscriptions: [
						{
							brand: "UnidragonEu",
							pointOfContact: "SMS"
						}
					]
				}
			},
			onSuccess: this.onSuccess()
		});
	}

	onSuccess() {
		if (this.collectMessages) {
			this.formField.classList.add("hidden");
			this.collectMessages.classList.remove("hidden");
			this.collectMessages.classList.add("success");

			this.collectMessages.innerHTML = "Form submit successfully"
		}

		if (this.submitButton){
			this.submitButton.disabled = true;
		}
	}
}

if (!customElements.get("phone-collect-form")){
	customElements.define("phone-collect-form", PhoneCollect)
}
